<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" title="发布作业详情" custom-class="custom-dialog"
            :close-on-click-modal="false" @opened="dialogOpen" @closed="dialogClose" width="790px">
 
            <table style="width: 100%; font-weight: 300;font-size: 14px; padding-top: 10px;">
                <tr>
                    <td width="185px" style="background-color: #F6F7FB;">作业标题：</td>
                    <td class="pricrTd" width="310px">{{ this.form.title }}</td>
                    <td width="165px" style="background-color: #F6F7FB;">班级名称：</td>
                    <td class="pricrTd" width="310px">{{ this.form.className}}</td>
                    <td width="185px" style="background-color: #F6F7FB;">截止提交时间：</td>
                    <td class="pricrTd" width="310px">{{ this.form.endSubmitTime }}</td>
                </tr>
                <tr>
                    <td width="165px" style="background-color: #F6F7FB;">作业内容：</td>
                    <td class="pricrTd" colspan="5">{{ this.form.content }}</td>
                </tr>
                <tr v-if="this.form.taskType == 2">
                    <td width="165px" style="background-color: #F6F7FB;">打卡模板：</td>
                    <td class="pricrTd" width="310px">{{ this.templateName }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">打卡模板任务：</td>
                    <td class="pricrTd" width="310px">{{ this.templateTaskName }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">允许补卡：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinPatchCardSign==1?'允许':'不允许' }}</td>
                </tr>
                <tr v-if="this.form.taskType == 2">
                    <td width="185px" style="background-color: #F6F7FB;">启动自动评价：</td>
                    <td class="pricrTd" width="310px"><span :style="{color: form.clockinAutoDp == 1 ? '' : 'red'}">{{ this.form.clockinAutoDp == 1 ? '启用': '禁用'  }}</span></td>
                    <td width="185px" style="background-color: #F6F7FB;">自动评价标题：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinAutoDpEvaluateTitle }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">自动评价分值：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinAutoDpEvaluateScore }}</td>
                </tr>
                <tr v-if="this.form.taskType == 2">
                    <td width="185px" style="background-color: #F6F7FB;">打卡开始日期：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinBeginDate }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">打卡结束日期：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinEndDate }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">打卡当前次数：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinCurrCount }}</td>
                </tr>
                <tr v-if="this.form.taskType == 2">
                    <td width="185px" style="background-color: #F6F7FB;">打卡总次数：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinTotalCount }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">打卡频次：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinFrequencyText }}</td>
                    <td width="185px" style="background-color: #F6F7FB;">提醒打卡：</td>
                    <td class="pricrTd" width="310px">{{ this.form.clockinRemindTime }}</td>
                </tr>
                <tr>
                    <td width="185px" style="background-color: #F6F7FB;">是否家长提交：</td>
                    <td class="pricrTd" width="310px"><span :style="{color: form.parentSubmitSign == 2 ? '' : 'red'}">{{ this.form.parentSubmitSign == 2 ? '是': '否' }}</span></td>
                    <td width="185px" style="background-color: #F6F7FB;" v-if="this.form.taskType == 2">结束后自动重发此打卡：</td>
                    <td class="pricrTd" width="310px" v-if="this.form.taskType == 2"><span :style="{color: form.clockinAutoResend == 1 ? '' : 'red'}">{{ this.form.clockinAutoResend == 1 ? '启用': '禁用' }}</span></td>
                    <td width="185px" style="background-color: #F6F7FB;" v-if="this.tasklist.fileCount > 0">作业附件：</td>
                    <td class="pricrTd" width="310px" v-if="this.tasklist.fileCount > 0"><el-link type="primary" @click="showFileInfo()">查看附件</el-link></td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogClose">关闭</el-button>
            </span>
        </el-dialog>
        
        <!-- 查看附件弹出框 -->
        <div v-if="taskFileVisible">
            <taskFile ref="taskFile"></taskFile>
        </div>
    </div>
</template>

<script>
import http from '../../../../common/http';
import taskFile from '../TaskFile.vue';

export default {
    name: 'addTemplateTask',
    components: {taskFile},
    props: {
        value: Boolean,
        tasklist: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            taskFileVisible:false,
            form: {},
            templateName: "",
            templateTaskName: ""
        }
    },
    watch: {
        value(val) {
            this.dialogVisible = val
        },
        dialogVisible(val) {
            this.$emit('input', val)
        },
    },
    created: function () {
    },
    methods: {
        dialogOpen() {
            if (this.$refs['form'] != undefined) {
                this.$refs['form'].resetFields();
            }
            this.getData()
        },
        dialogClose(){
            this.dialogVisible = false
        },
        getData(){
            let url  = this.taskListGetTaskListInfoUrl
            let data = {
               id: this.tasklist.id
            };
            // console.log(data);
            this.loading=true
            this.apiPost(url,data).then((res) => {
                if(res.status === 200){
                    this.form = res.data.taskList
                    this.templateName = res.data.templateName
                    this.templateTaskName = res.data.templateTaskName
                }else{
                    this.$commonFn.showTip(res.message,3)
                }
                this.loading=false
            },(err)=>{
                console.log(err)
                this.loading=false
            });
        },
        showFileInfo(){
            this.taskFileVisible=true;
            this.$nextTick(() => { 
                this.$refs['taskFile'].init(this.tasklist.id);
            })
        }
    },
    mixins: [http]
}

</script>

<style scoped>
table {
  border-collapse: separate;
  border-spacing: 0 10px; /* 垂直间距15px */
}
tr {
  height: 35px; /* 设置行高 */
}
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/showTasklistDetails.vue